import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, useIonToast } from '@ionic/react';
import Step from '../components/Step';

const Tab1: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Etapes</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Etapes</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Step race="3" />
      </IonContent>
    </IonPage>
  );
};

export default Tab1;
